module.exports = __webpack_public_path__ + "a83cc56dac9abc554b14956fdf4a1799.fbx";